import { render, staticRenderFns } from "./TaxDetails.vue?vue&type=template&id=0be258b6&scoped=true"
import script from "./TaxDetails.vue?vue&type=script&lang=js"
export * from "./TaxDetails.vue?vue&type=script&lang=js"
import style0 from "./TaxDetails.vue?vue&type=style&index=0&id=0be258b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be258b6",
  null
  
)

export default component.exports